import type { Circuit, CircuitVehicle } from '../types/track.js';
import {
  canPlaceAmbientCell,
  isGrandstandCell,
  isInfrastructureCell,
  isSignCell,
  isWithinGrid,
} from './circuitOccupancy.js';
import { isValidCircuitVehicleSpriteId } from './circuitVehicleCatalog.js';

function newVehicleId(): string {
  return `vh-${Math.random().toString(36).slice(2, 10)}`;
}

export { isValidCircuitVehicleSpriteId } from './circuitVehicleCatalog.js';

export function findVehicleAt(circuit: Circuit, x: number, y: number): CircuitVehicle | null {
  for (const vehicle of circuit.vehicles ?? []) {
    if (vehicle.x === x && vehicle.y === y) return vehicle;
  }
  return null;
}

export function canPlaceCircuitVehicle(circuit: Circuit, x: number, y: number): boolean {
  if (!isWithinGrid(circuit, x, y)) return false;
  if (isInfrastructureCell(circuit, x, y)) return false;
  if (isGrandstandCell(circuit, x, y) || isSignCell(circuit, x, y)) return false;
  return canPlaceAmbientCell(circuit, x, y);
}

export function addCircuitVehicle(
  circuit: Circuit,
  x: number,
  y: number,
  spriteId: string
): { circuit: Circuit } | { error: string } {
  if (!isValidCircuitVehicleSpriteId(spriteId)) {
    return { error: 'Modèle de véhicule inconnu' };
  }
  if (!canPlaceCircuitVehicle(circuit, x, y)) {
    return { error: 'Case invalide pour le véhicule' };
  }

  const withoutVehicle = removeVehicleAt(circuit, x, y);
  const vehicle: CircuitVehicle = { id: newVehicleId(), x, y, spriteId };
  return {
    circuit: {
      ...withoutVehicle,
      vehicles: [...(withoutVehicle.vehicles ?? []), vehicle],
    },
  };
}

export function removeVehicleAt(circuit: Circuit, x: number, y: number): Circuit {
  const vehicles = (circuit.vehicles ?? []).filter((vehicle) => vehicle.x !== x || vehicle.y !== y);
  return {
    ...circuit,
    vehicles: vehicles.length > 0 ? vehicles : undefined,
  };
}

export function pruneCircuitVehicles(circuit: Circuit): Circuit {
  const vehicles = (circuit.vehicles ?? []).filter((vehicle) => {
    if (!isWithinGrid(circuit, vehicle.x, vehicle.y)) return false;
    if (isInfrastructureCell(circuit, vehicle.x, vehicle.y)) return false;
    if (!isValidCircuitVehicleSpriteId(vehicle.spriteId)) return false;
    return true;
  });
  return {
    ...circuit,
    vehicles: vehicles.length > 0 ? vehicles : undefined,
  };
}
